<template>
  <div class="agent-transactions">
    <br />
    <h1 class="text-xs-center">Agent Transactions</h1>
    <div v-if="agentNameLabel" class="text-xs-center mb-2">{{ agentNameLabel }}</div>
    <div v-if="currentAgentError" class="text-xs-center pa-3">{{ currentAgentError }}</div>
    <div v-else>
      <form @submit.prevent="submitSearch">
        <v-layout row wrap>
          <v-flex xs12 sm6 md3 pa-2>
            <v-text-field
              solo
              clearable
              v-model="searchPhone"
              append-icon="fal fa-search"
              :rules="[v => !v || (/[\s\d-()+]+/.test(v) && v.length >= 2) || 'Please provide only numbers or \'+\' (min 2 digits)']"
              :disabled="apiInProgress"
              type="search"
              placeholder="Search by phone"
              @keyup.enter="submitSearch"
              @click:append="submitSearch"
            />
          </v-flex>
          <v-flex xs12 sm6 md2 pa-2>
            <v-select
              :items="logTypes"
              clearable
              label="Log Type"
              dense
              multiple
              single-line
              placeholder="Select Log Type(s)"
              v-model="selectedLogTypes"
            >
              <template v-slot:selection="{ item, index }">
                <small v-if="index === 0">{{ item.text }}</small>
                <small
                  v-if="index === 1"
                  class="grey--text caption pl-2"
                >(+{{ selectedLogTypes.length - 1 }} others)</small>
              </template>
            </v-select>
          </v-flex>
          <v-flex xs12 sm6 md3 pa-2>
            <st-date-field
              id="agent-transactions-date-from"
              v-model="dateFrom"
              label="From"
              hide-details
              with-time
              to-date-id="agent-transactions-date-to"
            />
          </v-flex>
          <v-flex xs12 sm6 md3 pa-2>
            <st-date-field
              id="agent-transactions-date-to"
              v-model="dateTo"
              label="To"
              hide-details
              with-time
              from-date-id="agent-transactions-date-from"
            />
          </v-flex>
          <v-flex xs12 sm6 md1 pa-2>
            <v-btn small fab type="submit"><v-icon small>fal fa-filter</v-icon></v-btn>
          </v-flex>
        </v-layout>
      </form>
      <div v-if="canViewPeriodTotals" class="layout justify-end px-2 mb-2">
        <v-btn
          small
          :disabled="apiInProgress"
          @click="totalsDialogOpen = true"
        >
          <v-icon left small>fas fa-calculator</v-icon>
          Profit report
        </v-btn>
      </div>
      <v-data-table
        :headers="headers"
        :items="transactions"
        :pagination.sync="pagination"
        :total-items="totalTransactions"
        :loading="apiInProgress"
        :rows-per-page-items="[10, 25, 50]"
        @update:pagination="onPagination"
        class="elevation-1"
        must-sort
      >
        <template v-slot:items="props">
          <tr class="tr--pointer" @click="openTransactionDetails(props.item)">
            <td>
              <div class="agent-transaction-type-cell">
                <v-icon
                  v-if="props.item.logTypeIconData"
                  small
                  class="mr-1"
                  :color="props.item.logTypeIconData.color"
                >{{ props.item.logTypeIconData.icon }}</v-icon>
                {{ props.item.logTypeIconData && props.item.logTypeIconData.label }}
              </div>
            </td>
            <td :class="props.item.amount < 0 ? 'text--muted' : ''">{{ props.item.amountLabel }}</td>
            <td>{{ props.item.profitLabel }}</td>
            <td>
              <div v-if="props.item.penaltyDetailLabel">{{ props.item.penaltyDetailLabel }}</div>
              <div v-if="props.item.penaltyHoldLabel">{{ props.item.penaltyHoldLabel }}</div>
              <div v-if="props.item.giftCounterpartyLabel">{{ props.item.giftCounterpartyRowLabel }} {{ props.item.giftCounterpartyLabel }}</div>
              <div v-if="props.item.passengerPhoneNumberLabel">Sent to {{ props.item.passengerPhoneNumberLabel }}</div>
              <div v-if="props.item.phoneNumberLabel">On {{ props.item.phoneNumberLabel }}</div>
            </td>
            <td>{{ props.item.profileBalanceBeforeLabel }}</td>
            <td>{{ props.item.profileBalanceAfterLabel }}</td>
            <td>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    v-on="on"
                    :color="props.item.logStatusIconData && props.item.logStatusIconData.color"
                  >{{ props.item.logStatusIconData && props.item.logStatusIconData.icon }}</v-icon>
                </template>
                <span>{{ props.item.logStatusLabel }}</span>
              </v-tooltip>
            </td>
            <td><small>{{ props.item.dateUpdatedLabel }}</small></td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <credit-period-totals-dialog
      v-if="canViewPeriodTotals"
      v-model="totalsDialogOpen"
      :agent-profile-id="currentAgent.id"
      :agent-name="agentNameLabel"
      :currency-symbol="currencyPrefix"
      :show-profit="true"
    />
    <agent-transaction-details-dialog
      v-model="detailsDialogOpen"
      :transaction="selectedTransaction"
      :can-refund-penalty="isAdmin"
      @refunded="loadPage"
    />
  </div>
</template>

<style lang="scss" scoped>
.agent-transaction-type-cell {
  display: flex;
  align-items: center;
}
</style>

<script>
import src from './src'
export default src
</script>
